import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function SignUp() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const { signUp, loading } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    // Validate password match
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const { error: signUpError } = await signUp(email, password);
      if (signUpError) {
        throw signUpError;
      }
      
      // Store email for OTP verification
      localStorage.setItem('signup_email', email);
      
      // Redirect to OTP verification
      navigate(`/verify-otp?email=${encodeURIComponent(email)}`);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Registration failed');
    }
  };

  return (
    <div className="pen-screen flex items-center justify-center px-5 py-8">
      <div className="pen-card w-full max-w-md border-t-[3px] border-t-sw-yellow">
        <div className="text-center mb-5">
          <Link
            to="/dashboard"
            className="inline-flex items-center justify-center h-10 px-3.5 bg-sw-yellow text-black font-black text-sm tracking-[0.1em] uppercase rounded-sm"
          >
            HYROX
          </Link>
          <p className="mt-3 text-[10px] tracking-[0.14em] uppercase text-sw-muted-2 font-mono font-light">
            Penalty Logger
          </p>
        </div>

        <h1 className="pen-title">Create your account</h1>
        <p className="pen-lede">Register as a race official</p>

        {error && <div className="pen-error mb-4">{error}</div>}

        <form className="space-y-3" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="email-address" className="pen-label">
              Email address
            </label>
            <input
              id="email-address"
              name="email"
              type="email"
              autoComplete="email"
              required
              className="pen-input"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="password" className="pen-label">
              Password
            </label>
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="new-password"
              required
              className="pen-input"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="confirm-password" className="pen-label">
              Confirm password
            </label>
            <input
              id="confirm-password"
              name="confirm-password"
              type="password"
              autoComplete="new-password"
              required
              className="pen-input"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          <button
            type="submit"
            disabled={loading || password !== confirmPassword}
            className="pen-btn-primary w-full mt-2"
          >
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <p className="text-center text-xs text-sw-muted mt-4">
          Already have an account?{' '}
          <Link to="/login" className="pen-link inline">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
